<template>
  <v-card>
    <v-card-title>
      <span class="headline">Details</span>
    </v-card-title>
    <v-card-text>
      <template v-for="(type, k) in types">
        <v-card :key="k">
          <v-expansion-panel v-if="type.subTypes && type.subTypes.length > 0" class="elevation-0">
            <v-expansion-panel-content v-for="(subType,j) in type.subTypes" :key="j">
              <div slot="header" class="v-input" v-if="subType.dets && subType.dets.length > 0">
                <v-icon>mdi-clipboard-text</v-icon>
                <span style="padding-left:5px">{{subType.desc}}</span>
              </div>
              <v-card-text v-if="subType.dets && subType.dets.length > 0">
                <template v-for="(detail, i) in subType.dets">
                  <div :key="i" class="qryResp">
                    <v-flex class="ma-0 pa-0">
                      <v-subheader class="queryLabel">{{detail.qryRefDesc}}</v-subheader>
                    </v-flex>
                    <v-flex class="ma-0 pa-0" v-if="detail.qryRefResp">
                      <span>{{detail.qryRefResp}}</span>
                    </v-flex>
                    <v-flex class="ma-0 pa-0" v-else>
                      <span>-</span>
                    </v-flex>
                  </div>
                </template>
              </v-card-text>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-card>
      </template>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn color="secondary" @click="doClose">
        Close
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  props: {
    clmSub: Object
  },
  methods: {
    doClose() {
      this.$emit('doClose')
    }
  },
  computed: {
    types() {
      return this.clmSub.types
    }
  }
}
</script>

<style scoped>
.qryResp {
  padding-bottom: 5px;
}
</style>
